import { ENTORNO } from "../api/Globals";

const getEnv = () => {
    if(ENTORNO === 'DEV'){
        return ENTORNO;
    }
    return window.location.pathname.split('/')[1]; // Copia o Produccion
};

const buildKey = (key) => {
    const env = getEnv();
    return `${env}_${key}`;
};

export const storage = {
    set: (key, value) => {
        sessionStorage.setItem(buildKey(key), JSON.stringify(value));
    },

    get: (key) => {
        const value = sessionStorage.getItem(buildKey(key));
        return value ? JSON.parse(value) : null;
    },

    remove: (key) => {
        sessionStorage.removeItem(buildKey(key));
    },

    clearEnv: () => {
        const env = getEnv();
        Object.keys(sessionStorage).forEach((key) => {
            if (key.startsWith(`${env}_`)) {
                sessionStorage.removeItem(key);
            }
        });
    }
};